module.exports = __webpack_public_path__ + "img/security.458f82ba.svg";